import firebase from './firebaseBundle'

const alreadyLoggedInWithFacebook = async (email) => {
  const signInMethods = await firebase.auth().fetchSignInMethodsForEmail(email)

  return !signInMethods.includes('password') && signInMethods.includes('facebook.com')
}

export default alreadyLoggedInWithFacebook
